"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var childrenToArray = function childrenToArray(children) {
  var result = [];

  _react.default.Children.forEach(children, function (child) {
    result.push(child);
  });

  return result;
};

var listOptions = {
  excessKey: true,
  exclusive: true,
  lastWordConnector: true,
  limit: true,
  locale: true,
  twoWordsConnector: true,
  wordsConnector: true
};

var _default = _react.default.createClass({
  displayName: "FormattedList",
  propTypes: {
    className: _react.default.PropTypes.string,
    excessKey: _react.default.PropTypes.string,
    exclusive: _react.default.PropTypes.bool,
    lastWordConnector: _react.default.PropTypes.string,
    limit: _react.default.PropTypes.number,
    locale: _react.default.PropTypes.string,
    twoWordsConnector: _react.default.PropTypes.string,
    wordsConnector: _react.default.PropTypes.string
  },
  getPassThroughProps: function getPassThroughProps() {
    var _this = this;

    var passThrough = {};
    Object.keys(this.props).forEach(function (key) {
      if (!listOptions[key]) {
        passThrough[key] = _this.props[key];
      }
    });
    return passThrough;
  },
  render: function render() {
    return _react.default.createElement("span", this.getPassThroughProps(), _I18n.default.formatListArray(childrenToArray(this.props.children), this.props));
  }
});

exports.default = _default;
module.exports = exports.default;